/* Índice del documento legal — sections/aud-legal.liquid
   Lo arma desde los h2 del cuerpo y marca la cláusula que se está leyendo.
   Sin JS el índice queda oculto y el documento se lee igual. */
(() => {
  const slug = (texto) =>
    texto.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'clausula';

  const armar = (seccion) => {
    const nav = seccion.querySelector('[data-aud-legal-indice]');
    const texto = seccion.querySelector('[data-aud-legal-texto]');
    if (!nav || !texto || nav.dataset.armado) return;
    nav.dataset.armado = '1';

    const titulos = [...texto.querySelectorAll('h2')];
    if (titulos.length < 2) return;

    const lista = nav.querySelector('ol');
    const usados = new Set();
    const enlaces = new Map();

    titulos.forEach((h2) => {
      let id = h2.id || slug(h2.textContent);
      while (usados.has(id) || (!h2.id && document.getElementById(id))) id += '-2';
      usados.add(id);
      h2.id = id;

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h2.textContent.trim();
      li.append(a);
      lista.append(li);
      enlaces.set(h2, a);
    });

    // En móvil el índice arranca cerrado: el documento va primero
    if (window.matchMedia('(max-width: 989px)').matches) nav.querySelector('details').open = false;
    nav.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    const observador = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        enlaces.forEach((a) => a.removeAttribute('aria-current'));
        enlaces.get(e.target)?.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-110px 0px -65% 0px' });
    titulos.forEach((h2) => observador.observe(h2));
  };

  const iniciar = () => document.querySelectorAll('.aud-legal').forEach(armar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
